import goTopButton from '@/components/GoTopButton'
import BaseButton from '@/components/BaseButton'
import SuccessDialogProduct from '@/components/SuccessDialogProduct'
import { showProductDetails } from '@/tools/utils.js'

export default {

  components: {
    goTopButton,
    BaseButton,
    SuccessDialogProduct
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      responseErr: null,
      errUpdatedParams: null,
      isProcessing: false,
      requestID: null,
      requestDetail: null,
      updatedParams: null,
      paramsDiff: null
    }
  },

  created () {
    this.requestID = this.$store.state.requests.requestID
    if (!this.requestID) {
      this.$store.dispatch('requests/invalidData', 'REQUEST_EMPTY')
      this.$router.push({ name: 'request-list' })
    }
    else {
      this.$store.dispatch('requests/resetInvalidData')
      this.getDetail()
    }
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('requests/detailReset')
      await this.$store.dispatch('requests/detail', {
        requestID: this.requestID
      }).then(
        () => {
          this.requestDetail = this.$store.state.requests.requestDetail
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )

      if (this.requestDetail && this.requestDetail.requestType == 'PRODUCT_UPDATE') {
        this.isProcessing = true
        if(this.requestDetail.requestStatus == 'DONE') {
          await this.$store.dispatch('requests/paramsDiffReset')
          await this.$store.dispatch('requests/paramsDiff', {
            requestID: this.requestID
          }).then(
            () => {
              this.isProcessing = false
              this.paramsDiff = this.$store.state.requests.paramsDiff
            },
            error => {
              this.isProcessing = false
              if(error.status === 404) {
                this.errUpdatedParams = 'NO_UPDATED_PARAMS'
              }
              else {
                this.responseErr = error.data || 'BAD_REQUEST'
              }
            }
          )
        }
        else if(this.requestDetail.requestStatus == 'FAILED') {
          await this.$store.dispatch('requests/updatedParamsReset')
          await this.$store.dispatch('requests/updatedParams', {
            requestID: this.requestID
          }).then(
            () => {
              this.isProcessing = false
              this.updatedParams = this.$store.state.requests.updatedParams
            },
            error => {
              this.isProcessing = false
              if(error.status === 404) {
                this.errUpdatedParams = 'NO_UPDATED_PARAMS'
              }
              else {
                this.responseErr = error.data || 'BAD_REQUEST'
              }
            }
          )
        }
        else {
          await this.$store.dispatch('requests/requestParamsReset')
          await this.$store.dispatch('requests/requestParams', {
            requestID: this.requestID
          }).then(
            () => {
              this.isProcessing = false
              let rawUpdatedParams = this.$store.state.requests.requestParams
              this.updatedParams = {
                params: rawUpdatedParams
              }
            },
            error => {
              this.isProcessing = false
              if(error.status === 404) {
                this.errUpdatedParams = 'NO_UPDATED_PARAMS'
              }
              else {
                this.responseErr = error.data || 'BAD_REQUEST'
              }
            }
          )
        }
      }
      else {
        this.isProcessing = false
      }
    },

    showProduct (productExternalReference) {
      this.$store.dispatch('products/setProduct',{
        prb1: productExternalReference,
        prb7: this.requestDetail.requestProductDescription[0].params[6].value[0]
      })
      return showProductDetails()
    },

    async showEdit () {
      this.$router.push({ name: 'request-edit' })
    },

    async cancel () {
      this.$store.dispatch('requests/cancel', {
        requestID: this.requestID
      }).then(
        () => {
          this.showSuccess(this.$i18n.t('label.request.cancelSuccess'))
        },
        error => {
          this.error = true
          this.responseErr = error.data || 'error.BAD_REQUEST'
        }
      )
    },

    showSuccess (msg) {
      this.$refs.successDialogRef.showSuccess(msg)
    },

    isModified (fieldName) {
      fieldName = fieldName.replace('-', '')
      if (this.updatedParams) {
        for (const key in this.updatedParams.params) {
          if (key.replace('-', '') == fieldName || this.updatedParams.params[key] == fieldName) {
            return true
          }
        }
      }
      return false
    }
  }
}
